import React from 'react';
import {
  BackgroundWrapper,
  BoxImage,
  ButtonContainer,
  CloseIconContainer,
  ContentWrapper,
  ImageBoxContainer,
  LogoContainer,
  LogoImage,
  OverlayContent,
  ParagraphContainer,
  ParagraphHeading,
  ParagraphIntro,
  PopUpWrapper,
  StyledImage,
} from './LqaAcademyNews.styled';
import { Close } from '../../common/Icons/Close';
import { ButtonMedium } from 'components/button/ButtonMedium';
import { useTranslation } from 'react-i18next';
import { addUserToSeenList } from 'helpers/LqaAcademyNewsPopUpDisplay';

interface LqaAcademyNewsProps {
    onClose: () => void;
}

export function LqaAcademyNews({ onClose }: LqaAcademyNewsProps) {
  const { t } = useTranslation();
  function handleClose() {
    addUserToSeenList();
    onClose();
  }

  function handleLearnMore() {
    handleClose();
    window.open('https://academylqa.com/', '_blank', 'noopener');
  }

  const leftImageUrl = 'https://s3.us-east-1.amazonaws.com/com.lqa.v5.images.dev/popup-message/left_image.png';
  const rightImageUrl = 'https://s3.us-east-1.amazonaws.com/com.lqa.v5.images.dev/popup-message/right_image.png';
  const logoImageUrl = 'https://s3.us-east-1.amazonaws.com/com.lqa.v5.images.dev/popup-message/Logo.svg';
  const boxImageUrl = 'https://s3.us-east-1.amazonaws.com/com.lqa.v5.images.dev/popup-message/img_box.png';

  return (
    <>
      <PopUpWrapper>
        <CloseIconContainer onClick={handleClose}>
          <Close fillColor={'#fff'} />
        </CloseIconContainer>
        <BackgroundWrapper>
          <OverlayContent>
            <StyledImage src={leftImageUrl} alt="Left" flex={1} />
            <LogoContainer>
              <LogoImage src={logoImageUrl} alt="Center" />
            </LogoContainer>
            <StyledImage
              src={rightImageUrl}
              alt="Right"
              flex={1}
            />
          </OverlayContent>
        </BackgroundWrapper>
        <ContentWrapper>
          <ParagraphContainer>
            <ParagraphHeading>
            {t('common.LQA_ACADEMY_NEWS.HEADING_DESCRIPTION')}
            </ParagraphHeading>
            <ParagraphIntro>
            {t('common.LQA_ACADEMY_NEWS.PARA_HEADING')}
            </ParagraphIntro>
            <ButtonContainer>
              <ButtonMedium title={t('common.LQA_ACADEMY_NEWS.LEARN_MORE')} onClick={handleLearnMore} />
            </ButtonContainer>
          </ParagraphContainer>

          <ImageBoxContainer>
            <BoxImage src={boxImageUrl} alt="Right aligned image" />
          </ImageBoxContainer>
        </ContentWrapper>
      </PopUpWrapper>
    </>
  );
}
